import styled, { css } from 'styled-components';
import { colors } from './Styles';

/**
 * A layout element used inside a Dashboard-wrapped container
 */
export const RhCard = styled.div<{
  mode?: 'main' | 'mini' | 'tiled' | 'module';
  hoverable?: boolean;
  background?: string;
}>`
  padding: ${({ mode = 'main' }) => {
    switch (mode) {
      case 'main':
        return '18px 16px 18px 23px';
      case 'mini':
        return '12.5px 13px';
      case 'tiled':
        return '14px 17px';
      case 'module':
        return '10px 17px 10px 10px';
      default:
        break;
    }
  }};
  background: ${({ background = '#fff' }) => background};
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        background: ${colors.background};
        cursor: pointer;
      }
    `}
`;
